var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "extents-panel" }, [
    _c("div", { staticClass: "extents-label" }, [_vm._v("EXTENT")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "extents-row" },
      _vm._l(_vm.extents, function (extent) {
        return _c(
          "div",
          {
            key: extent.id,
            staticClass: "extent-card",
            class: {
              "extent-card--active":
                extent.extent_description === _vm.selectedExtent,
            },
            on: {
              click: function ($event) {
                extent.extent_description !== _vm.selectedExtent &&
                  _vm.changeExtent(extent)
              },
            },
          },
          [
            _c("img", {
              staticClass: "extent-img",
              attrs: { src: _vm.getExtentImg(extent.extent_description) },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "extent-name" }, [
              _vm._v(_vm._s(extent.extent_description)),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }